import { render, staticRenderFns } from "./SetModello.vue?vue&type=template&id=02415875"
import script from "./SetModello.vue?vue&type=script&lang=js"
export * from "./SetModello.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports